import theme from '../../../theme';

const onboardingHeaderStyle = {
  ...theme?.components?.dashboardOnboarding?.header?.typography,
  ...theme?.components?.dashboardOnboarding?.header?.palette,
  margin: theme.spacing(0, 1, 0, 0),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  height: 39,
};
export default onboardingHeaderStyle;
